import { render } from "./TestData.vue?vue&type=template&id=72ae38c5&ts=true"
import script from "./TestData.vue?vue&type=script&lang=ts"
export * from "./TestData.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__